import { fetchDelete, fetchGet, fetchPatch, fetchPost } from "@/lib/services";

export async function getEmployees(role?: string, page?: number, search?: string, status?: string) {
  const params = new URLSearchParams();
  if (role) params.append('Role', role);
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status) params.append('Status', status);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/employees/${query}`);
}

export async function createEmployee(data: any) {
  return await fetchPost("/employees/", data);
}

export async function updateEmployee(id: number, data: any) {
  return await fetchPatch(`/employees/?Id=${id}`, data);
}

export async function deleteEmployee(id: number) {
  return await fetchDelete(`/employees/?Id=${id}`);
} 

export async function getEmployeeByUsername(username: string) {
    return await fetchGet(`/employees/?Username=${username}`);
}

export async function getRegisteredUsers(page?: number, search?: string, branchCode?: string,status?: string) {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (branchCode) params.append('Branch_Code', branchCode);
  if (status) params.append('Status', status);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/registeredprofiles/${query}`);
}

export async function createRegisteredUser(data: any) {
  return await fetchPost("/registeredcreate/", data);
}

export async function updateRegisteredUser(id: number, data: any) {
  return await fetchPatch(`/registeredprofiles/?Id=${id}`, data);
}

export async function deleteRegisteredUser(id: number) {
  return await fetchDelete(`/registeredprofiles/?Id=${id}`);
} 

export async function getRegisteredUserByUsername(username: string) {
    return await fetchGet(`/registeredprofiles/?Username=${username}`);
}

export async function getPaymentPendingUsers(search?: string,page?: number,) {
   const params = new URLSearchParams();
     if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  const query = params.toString() ? `?${params.toString()}` : '';
    return await fetchGet(`/pending-payment-child/${query}`);
}

